import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {App} from "./app/App";
import {GlobalStoreProvider} from "./app/global-store/GlobalStoreContext";

ReactDOM.render(
    <React.StrictMode>
        <GlobalStoreProvider>
            <App/>
        </GlobalStoreProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

